import DashboardLayout from '@/layouts/DashboardLayout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/_dashboard')({
  component: DashboardLayout,
});
